import { Button } from 'components/Form'
import ModalWrapper from 'components/ModalWrapper'
import React, { } from 'react'
import { I18n } from 'react-redux-i18n'
import { getStaticImage } from 'utils/statics'
import './styles.scss'

const DelegateModalOK = (props) => {
  const { isOpen, toggle } = props
  return (
    <ModalWrapper
      id={'modalAccountDelegateOK'}
      header=' '
      body={
        <div className='delegate-ok-wrapper'>
          <img className={`check-ok-image`} alt={'check'} src={getStaticImage(`/icons/orange-brand/icon-check-full.svg`)} />
          <h1>{`${I18n.t('dashboard_thats-it')}`}</h1>
          <legend>{`${I18n.t('ecommerce_credential_created')}`}</legend>
          <Button secondary value={`${I18n.t('dashboard_ok')}`} onClick={toggle} />
        </div>
      }
      isOpen={isOpen}
      toggle={toggle}
      showClose={true}
    />
  )
}

export default DelegateModalOK
